module.exports = __webpack_public_path__ + "static/media/emo-new.1b667f3a.svg";